import { createWebHistory, createRouter } from "vue-router";
import LogIn from '@/views/Auth/Login.vue';
import Mfa from '@/views/Auth/MfaVerify.vue';
import ForgotPassword from '@/views/Auth/ForgotPassword.vue';
import ResetPassword from '@/views/Auth/ResetPassword.vue';
import SignUp from '@/views/Auth/SignUp.vue';

import Home from '@/views/Home/Home.vue';
import Logbook from '@/views/Logbook/Index.vue';
import LifecycleBirth from '@/views/Lifecycle/Birth.vue';
import MigrationImport from '@/views/Migration/Import.vue';

import Departure from '@/views/Departure/Index.vue';
import DepartureCreate from '@/views/Departure/Create.vue';
import DepartureEdit from '@/views/Departure/Edit.vue';
import DepartureOverview from '@/views/Departure/Overview.vue';

import Death from '@/views/Death/Index.vue';
import DeathCreate from '@/views/Death/Create.vue';
import DeathEdit from '@/views/Death/Edit.vue';
import DeathOverview from '@/views/Death/Overview.vue';

import Missing from '@/views/Missing/Index.vue';
import MissingCreate from '@/views/Missing/Create.vue';
import MissingEdit from '@/views/Missing/Edit.vue';
import MissingOverview from '@/views/Missing/Overview.vue';

import Animal from '@/views/Animal/Index.vue';
import AnimalCreate from '@/views/Animal/Create.vue';
import AnimalEdit from '@/views/Animal/Edit.vue';
import AnimalPreview from '@/views/Animal/Details.vue';
import AnimalPedigree from '@/views/Animal/Pedigree.vue';
import AnimalPedigreeNew from '@/views/Animal/PedigreeNew.vue';

import Location from '@/views/Location/Index.vue';
import LocationCreate from '@/views/Location/Create.vue';
import LocationEdit from '@/views/Location/Edit.vue';
import LocationPreview from '@/views/Location/Details.vue';
import StablelistReport from '@/views/Location/Report.vue';
import InvullijstReport from '@/views/Location/Invullijst.vue';

import Mating from '@/views/Mating/Index.vue';
import MatingCreate from '@/views/Mating/Create.vue';
import MatingEdit from '@/views/Mating/Edit.vue';
import MatingPreview from '@/views/Mating/Details.vue';

import Testmating from '@/views/Testmating/Index.vue';
import TestmatingCreate from '@/views/Testmating/Create.vue';
import TestmatingReport from '@/views/Testmating/Report.vue';

import Birth from '@/views/Birth/Index.vue';
import BirthRegister from '@/views/Birth/Register.vue';
import NewBornRegister from '@/views/Birth/AddNewBorn.vue';

import Eartag from '@/views/Eartag/Index.vue';
import EartagPreview from '@/views/Eartag/Details.vue';
import Retagging from '@/views/Retagging/Index.vue';
import RetaggingCreate from '@/views/Eartag/Retagging.vue';
import Aretagging from '@/views/Retagging/Process.vue';

import Search from '@/views/Search/Index.vue';

import Association from '@/views/Association/Index.vue';
import AssociationCreate from '@/views/Association/Create.vue';
import AssociationEdit from '@/views/Association/Edit.vue';
import AssociationPreview from '@/views/Association/Details.vue';

import AttributeCreate from '@/views/Attribute/Create.vue';
import AttributeEdit from '@/views/Attribute/Edit.vue';

import ReferenceTypeCreate from '@/views/ReferenceType/Create.vue';
import ReferenceTypeEdit from '@/views/ReferenceType/Edit.vue';

import UserManualTypeCreate from '@/views/UserManualType/Create.vue';
import UserManualTypeEdit from '@/views/UserManualType/Edit.vue';

import UserManualCreate from '@/views/UserManual/Create.vue';
import UserManualEdit from '@/views/UserManual/Edit.vue';

import NotificationCreate from '@/views/Notification/Create.vue';
import NotificationEdit from '@/views/Notification/Edit.vue';

import ReferenceCreate from '@/views/Reference/Create.vue';
import ReferenceEdit from '@/views/Reference/Edit.vue';

import MailTemplateCreate from '@/views/MailTemplate/Create.vue';
import MailTemplateEdit from '@/views/MailTemplate/Edit.vue';

import AboutUs from '@/components/AboutUs.vue';
import Profile from '@/views/Profile/Index.vue';
import User from '@/views/User/Index.vue';
import UserCreate from '@/views/User/Create.vue';
import UserEdit from '@/views/User/Edit.vue';
import Register from '@/views/Register/Index.vue';
import RegisterEdit from '@/views/Register/Edit.vue';
import RegisterCreate from '@/views/Register/Create.vue';
import Settings from '@/views/Settings/Index.vue';
import BreedCreate from '@/views/Breed/Create.vue';
import BreedEdit from '@/views/Breed/Edit.vue';
import StudebookStatusCreate from '@/views/StudebookStatus/Create.vue';
import StudebookStatusEdit from '@/views/StudebookStatus/Edit.vue';
import StudebookSectionCreate from '@/views/StudebookSection/Create.vue';
import StudebookSectionEdit from '@/views/StudebookSection/Edit.vue';


import NotFound from '@/components/NotFound.vue';
import axios from 'axios';
import store from '@/store';
//import store from '../store'

const routes = [
    {
        path: "/",
        name: "Home",
        component: Home,
        meta: { requiresAuth: true }
    },
    {
        path: '/animal',
        name: "Animal",
        component: Animal,
        meta: { requiresAuth: true }
    },    
    {
        path: '/animal/create/:id',
        name: "New Animal",
        component: AnimalCreate,
        meta: { requiresAuth: true }
    },
    {
        path: '/animal/edit/:id',
        name: "Edit Animal",
        component: AnimalEdit,
        meta: { requiresAuth: true }
    },
    {
        path: '/animal/details/:id',
        name: "Preview Animal",
        component: AnimalPreview,
        meta: { requiresAuth: true }
    },
    {
        path: '/animal/pedigree/:id',
        name: "Animal Pedigree",
        component: AnimalPedigree,
        meta: { requiresAuth: true }
    },
    {
        path: '/animal/pedigreenew/:id',
        name: "Animal PedigreeNew",
        component: AnimalPedigreeNew,
        meta: { requiresAuth: true }
    },
    {
        path: '/logbook',
        name: "Logbook",
        component: Logbook,
        meta: { requiresAuth: true }
    },
    {
        path: '/departure',
        name: "Departure",
        component: Departure,
        meta: { requiresAuth: true }
    },
    {
        path: '/departure/create/:id',
        name: "New Departure",
        component: DepartureCreate,
        meta: { requiresAuth: true }
    },
    {
        path: '/departure/edit/:id',
        name: "Edit Departure",
        component: DepartureEdit,
        meta: { requiresAuth: true }
    },
    {
        path: '/departure/overview/:id',
        name: "Overview Departure",
        component: DepartureOverview,
        meta: { requiresAuth: true }
    },
    {
        path: '/death',
        name: "Death",
        component: Death,
        meta: { requiresAuth: true }
    },
    {
        path: '/death/create/:id',
        name: "New Death",
        component: DeathCreate,
        meta: { requiresAuth: true }
    },
    {
        path: '/death/edit/:id',
        name: "Edit Death",
        component: DeathEdit,
        meta: { requiresAuth: true }
    },
    {
        path: '/death/overview/:id',
        name: "Overview Death",
        component: DeathOverview,
        meta: { requiresAuth: true }
    },
     {
        path: '/missing',
        name: "Missing",
        component: Missing,
        meta: { requiresAuth: true }
    },
    {
        path: '/missing/create/:id',
        name: "New Missing",
        component: MissingCreate,
        meta: { requiresAuth: true }
    },
    {
        path: '/missing/edit/:id',
        name: "Edit Missing",
        component: MissingEdit,
        meta: { requiresAuth: true }
    },
    {
        path: '/missing/overview/:id',
        name: "Overview Missing",
        component: MissingOverview,
        meta: { requiresAuth: true }
    },
    {
        path: '/migration/import',
        name: "Import",
        component: MigrationImport,
        meta: { requiresAuth: true }
    },
    {
        path: '/lifecycle/birth',
        name: "Birth",
        component: LifecycleBirth,
        meta: { requiresAuth: true }
    },    
    {
        path: '/login',
        name: "Login",
        component: LogIn,
        meta: { requiresAuth: false }
    },
    {
        path: '/mfa',
        name: "Mfa",
        component: Mfa,
        meta: { requiresAuth: false }
    },
    {
        path: '/forgot-password',
        name: "ForgotPassword",
        component: ForgotPassword,
        meta: { requiresAuth: false }
    },
    {
        path: '/resetpassword',
        name: "ResetPassword",
        component: ResetPassword,
        meta: { requiresAuth: true }
    },
    {
        path: '/signup',
        name: "signup",
        component: SignUp,
        meta: { requiresAuth: false }
    },
    {
        path: '/aboutus',
        name: "aboutus",
        component: AboutUs,
        meta: { requiresAuth: false }
    },
    {
        path: '/profile',
        name: "Profile",
        component: Profile,
        meta: { requiresAuth: true }
    },
    {
        path: '/user',
        name: "User",
        component: User,
        meta: { requiresAuth: true }
    },    
    {
        path: '/user/create/:id',
        name: "New User",
        component: UserCreate,
        meta: { requiresAuth: true }
    },    
    {
        path: '/user/edit/:id',
        name: "Edit User",
        component: UserEdit,
        meta: { requiresAuth: true }
    },    
    {
        path: '/location',
        name: "Location",
        component: Location,
        meta: { requiresAuth: true }
    },    
    {
        path: '/location/create/:id',
        name: "New Location",
        component: LocationCreate,
        meta: { requiresAuth: true }
    },    
    {
        path: '/location/edit/:id',
        name: "Edit Location",
        component: LocationEdit,
        meta: { requiresAuth: true }
    },
    {
        path: '/location/details/:id',
        name: "Preview Location",
        component: LocationPreview,
        meta: { requiresAuth: true }
    },
    {
        path: '/location/report/:id',
        name: "Report Stablelist",
        component: StablelistReport,
        meta: { requiresAuth: true }
    },
    {
        path: '/location/invullijst/:id',
        name: "Report Invullijst",
        component: InvullijstReport,
        meta: { requiresAuth: true }
    },
    {
        path: '/mating',
        name: "Mating",
        component: Mating,
        meta: { requiresAuth: true }
    },    
    {
        path: '/mating/create/:id',
        name: "New Mating",
        component: MatingCreate,
        meta: { requiresAuth: true }
    },
    {
        path: '/mating/edit/:id',
        name: "Edit Mating",
        component: MatingEdit,
        meta: { requiresAuth: true }
    },
    {
        path: '/mating/details/:id',
        name: "Preview Mating",
        component: MatingPreview,
        meta: { requiresAuth: true }
    },
    {
        path: '/testmating',
        name: "Testmating",
        component: Testmating,
        meta: { requiresAuth: true }
    },    
    {
        path: '/testmating/create/:id',
        name: "New Testmating",
        component: TestmatingCreate,
        meta: { requiresAuth: true }
    },
    {
        path: '/testmating/report/:id',
        name: "Report Testmating",
        component: TestmatingReport,
        meta: { requiresAuth: true }
    },
    {
        path: '/birth',
        name: "Birth",
        component: Birth,
        meta: { requiresAuth: true }
    },    
    {
        path: '/birth/register/:id',
        name: "Register Birth",
        component: BirthRegister,
        meta: { requiresAuth: true }
    },
    {
        path: '/birth/addnewborn/:id/:ubnId',
        name: "Register NewBorn",
        component: NewBornRegister,
        meta: { requiresAuth: true }
    },   
    {
        path: '/eartag',
        name: "Eartag",
        component: Eartag,
        meta: { requiresAuth: true }
    },
    {
        path: '/retagging',
        name: "Retagging",
        component: Retagging,
        meta: { requiresAuth: true }
    },
    {
        path: '/retagging/create/:id',
        name: "New Retagging",
        component: RetaggingCreate,
        meta: { requiresAuth: true }
    },    
    {
        path: '/aretagging',
        name: "Aretagging",
        component: Aretagging,
        meta: { requiresAuth: true }
    },    
    {
        path: '/eartag/details/:id',
        name: "Preview Eartag",
        component: EartagPreview,
        meta: { requiresAuth: true }
    },
    {
        path: '/search',
        name: "Search",
        component: Search,
        meta: { requiresAuth: true }
    },    
    {
        path: '/referencetype/create',
        name: "New ReferenceType",
        component: ReferenceTypeCreate,
        meta: { requiresAuth: true }
    },    
    {
        path: '/referencetype/edit/:id',
        name: "Edit ReferenceType",
        component: ReferenceTypeEdit,
        meta: { requiresAuth: true }
    },
    {
        path: '/usermanualtype/create',
        name: "New UserManualType",
        component: UserManualTypeCreate,
        meta: { requiresAuth: true }
    },    
    {
        path: '/usermanualtype/edit/:id',
        name: "Edit UserManualType",
        component: UserManualTypeEdit,
        meta: { requiresAuth: true }
    },
    {
        path: '/usermanual/create',
        name: "New UserManual",
        component: UserManualCreate,
        meta: { requiresAuth: true }
    },    
    {
        path: '/usermanual/edit/:id',
        name: "Edit UserManual",
        component: UserManualEdit,
        meta: { requiresAuth: true }
    },
    {
        path: '/attribute/create',
        name: "New Attribute",
        component: AttributeCreate,
        meta: { requiresAuth: true }
    },
    {
        path: '/attribute/edit/:id',
        name: "Edit Attribute",
        component: AttributeEdit,
        meta: { requiresAuth: true }
    },
    {
        path: '/notification/create',
        name: "New Notification",
        component: NotificationCreate,
        meta: { requiresAuth: true }
    },    
    {
        path: '/notification/edit/:id',
        name: "Edit Notification",
        component: NotificationEdit,
        meta: { requiresAuth: true }
    },
    {
        path: '/reference/create',
        name: "New Reference",
        component: ReferenceCreate,
        meta: { requiresAuth: true }
    },    
    {
        path: '/reference/edit/:id',
        name: "Edit Reference",
        component: ReferenceEdit,
        meta: { requiresAuth: true }
    },
    {
        path: '/register',
        name: "Register",
        component: Register,
        meta: { requiresAuth: true }
    },  
    {
        path: '/register/create',
        name: "New Register",
        component: RegisterCreate,
        meta: { requiresAuth: true }
    },
    {
        path: '/register/edit/:id',
        name: "Edit Register",
        component: RegisterEdit,
        meta: { requiresAuth: true }
    },
    {
        path: '/association',
        name: "Association",
        component: Association,
        meta: { requiresAuth: true }
    },      
    {
        path: '/association/create',
        name: "New Association",
        component: AssociationCreate,
        meta: { requiresAuth: true }
    },    
    {
        path: '/association/edit/:id',
        name: "Edit Association",
        component: AssociationEdit,
        meta: { requiresAuth: true }
    },
    {
        path: '/association/details/:id',
        name: "Preview Association",
        component: AssociationPreview,
        meta: { requiresAuth: true }
    },   
    {
        path: '/settings',
        name: "Settings",
        component: Settings,
        meta: { requiresAuth: true }
    },    
    {
        path: '/breed/create',
        name: "New Breed",
        component: BreedCreate,
        meta: { requiresAuth: true }
    }, 
    {
        path: '/breed/edit/:id',
        name: "Edit Breed",
        component: BreedEdit,
        meta: { requiresAuth: true }
    }, 
    {
        path: '/studebookstatus/create',
        name: "New StudebookStatus",
        component: StudebookStatusCreate,
        meta: { requiresAuth: true }
    }, 
    {
        path: '/studebookstatus/edit/:id',
        name: "Edit StudebookStatus",
        component: StudebookStatusEdit,
        meta: { requiresAuth: true }
    }, 
    {
        path: '/studebooksection/create',
        name: "New StudebookSection",
        component: StudebookSectionCreate,
        meta: { requiresAuth: true }
    }, 
    {
        path: '/studebooksection/edit/:id',
        name: "Edit StudebookSection",
        component: StudebookSectionEdit,
        meta: { requiresAuth: true }
    },
    {
        path: '/mailtemplate/create',
        name: "New MailTemplate",
        component: MailTemplateCreate,
        meta: { requiresAuth: true }
    },    
    {
        path: '/mailtemplate/edit/:id',
        name: "Edit MailTemplate",
        component: MailTemplateEdit,
        meta: { requiresAuth: true }
    },       
    {        
        path: '/:catchAll(.*)',
        name: 'NotFound',
        component: NotFound
    }
];

const router = createRouter({
    history: createWebHistory(),
    routes,
});

router.beforeEach((to, from, next) => {

    document.title = to.name
        ? `${to.name} | veeboek-app`
        : 'veeboek-app';

    let user = store.getters['user'];

    // If user is not in Vuex, try to load from localStorage
    if (!user) {
        const userFromStorage = localStorage.getItem('user');
        const token = localStorage.getItem('sheepbase-token');

        if (userFromStorage && token) {
            user = JSON.parse(userFromStorage);
            store.commit('user', user);
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
            store.commit('setShowNavbar', true);
        }
    }

    const requiresAuth = to.matched.some(record => record.meta.requiresAuth);

    if (requiresAuth && !user) {
        next('/login');
    } else {
        next();
    }
});

/*
router.beforeEach ((to, from, next) => {
    var user = store.getters['user'];
    console.log(user);
    console.log(to.matched.some(record => record.meta.requiresAuth));
    if(to.matched.some(record => record.meta.requiresAuth) && !user) {
        router.push('/login');
    } else if (!to.matched.some(record => record.meta.requiresAuth) && user) {                
        next(); 
    } else {
        next(); 
    }
});
*/
export default router;